import { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { imageUrl } from '../lib/images';

export default function GalleryLightboxModal({ images = [], currentIndex = 0, isOpen = false, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen || !images.length) return null;

  const currentImg = images[currentIndex];

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm p-4 text-white animate-in fade-in duration-200"
      onClick={onClose}
    >
      {/* Top Bar */}
      <div className="absolute top-4 left-4 right-4 flex items-center justify-between z-10 text-stone-300 text-sm font-medium">
        <span>Billede {currentIndex + 1} af {images.length}</span>
        <button
          onClick={onClose}
          className="p-2.5 bg-white/10 hover:bg-white/20 text-white transition-colors cursor-pointer"
          aria-label="Luk galleri"
        >
          <X className="w-6 h-6" />
        </button>
      </div>

      {/* Main Image Container */}
      <div 
        className="relative max-w-5xl max-h-[85vh] w-full h-full flex items-center justify-center p-2"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imageUrl(currentImg, 'width=1600,quality=85,format=auto')}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain shadow-2xl select-none"
        />

        {/* Navigation Arrows */}
        {images.length > 1 && (
          <>
            <button
              onClick={onPrev}
              className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 p-3 sm:p-4 bg-stone-900/80 hover:bg-amber-700 text-white transition-all cursor-pointer shadow-lg border border-white/10"
              aria-label="Forrige billede"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              onClick={onNext}
              className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 p-3 sm:p-4 bg-stone-900/80 hover:bg-amber-700 text-white transition-all cursor-pointer shadow-lg border border-white/10"
              aria-label="Næste billede"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
